import moment, {Moment} from 'moment';
import {StatisticsBinning} from '../../backend/enums/statistics-binning';
import {TimeLapseType} from '../../enums/time-lapse-type';
import {TimeLapseValue} from '../../interfaces/time-lapse-value';

/**
 * Get the StatisticsBinning given a TimeLapseValue.
 *
 * @deprecated Use getStatisticsBinningByDates instead.
 */
export const getStatisticsBinning = (lapse: TimeLapseValue): StatisticsBinning => {
  switch (lapse.type) {
    case TimeLapseType.ThisWeek:
      return StatisticsBinning.DateOfTheMonth;
    case TimeLapseType.ThisMonth:
      return StatisticsBinning.DateOfTheMonth;
    case TimeLapseType.LastWeek:
      return StatisticsBinning.DateOfTheMonth;
    case TimeLapseType.LastMonth:
      return StatisticsBinning.DateOfTheMonth;
    case TimeLapseType.Last365Days:
      return StatisticsBinning.Month;
    case TimeLapseType.Last30Days:
      return StatisticsBinning.DateOfTheMonth;
    case TimeLapseType.Last180Days:
      return StatisticsBinning.Month;
    case TimeLapseType.Custom:
      // Get the difference between the time lapse in days
      const numberOfDays: number = moment(lapse.range[1]).diff(moment(lapse.range[0]), 'days');

      // Show by month if the number of days is superior to 60 (2 months)
      return numberOfDays > 60 ? StatisticsBinning.Month : StatisticsBinning.DateOfTheMonth;
    default:
      return StatisticsBinning.Month;
  }
};

export const getStatisticsBinningByDates = (start: Moment, end: Moment): StatisticsBinning => {
  const numberOfDays: number = end.diff(start, 'days');
  return numberOfDays > 60 ? StatisticsBinning.Month : StatisticsBinning.DateOfTheMonth;
};
